import {IRaDetailView, IRaDetailViewBillingOwnerCompany, IRaDetailViewBillingOwnerInfo, IRaDetailViewBillingOwnerPerson, IRaDetailViewBillingOwnerVAT} from "../models/models";

export const PAYMENT_METHODS_CODES = ['B', 'D', 'F', 'I', 'J', 'K', 'M', 'P', 'Q', 'R', 'S', 'T', 'X', 'Z'];

export const RA_DETAIL_INITIAL_VALUE: IRaDetailView = {
	generalInfo: {
		raNumber: '',
		dmsIdentificationCode: null,
		pickupDate: null,
		renewalsAndSubstitutions: '',
		raStatus: null,
		dmsOperator: '',
		reservationNumber: '',
		dossier: '',
		totalRentalDays: '',
		effectiveRentalDays: '',
		mileageIncluded: '',
		bookedVehicleType: '',
		upSell: false,
		bookedAcriss: '',
		bookedAcrissModel: '',
		billedCarGroup: '',
		billedCarGroupModel: '',
		rfidCard: '',
		keyless: false,
		effectiveAcrissId: '',
		effectiveAcrissDescription: '',
		plateNumber: '',
		vehicleId: '',
		toBeReconciled: false,

		pickupLocation: null,
		expectedPickupDate: null,
		actualRentalStart: null,
		kmOnStart: '',
		tankLevelOnStart: '',
		batteryOnStart: '',

		kmsOnCheck: '',
		tankLevelOnCheck: '',
		batteryOnCheck: '',

		dropoffLocation: null,
		expectedDropoffDate: null,
		actualDropoffDate: null,
		dropOffKmOnCheck: '',
		dropOffTankLevelOnCheck: '',
		dropOffbatteryOnCheck: ''
	},
	substitutionInfo: [],
	financialInfo: {
		segment: '',
		category: '',
		product: '',
		rate: '',
		businessAgreement: '',
		creditType: '',
		firstPreauthCardNumber: '',
		secondPreauthCardNumber: '',
		paymentCardNumber: ''
	},
	quotationInfo: {
		reservedTariffs: false,
		rentalAmount: '',
		bookedAncillariesAmount: '',
		addedAncillariesAmount: '',
		totalAmountTaxIncluded: '',
		airportTax: '',
		railwayTax: '',
		roadTax: '',
		totalAmountTaxExcluded: '',
		damageExcess: '',
		fireTheftExcess: '',
		discountsApplied: ''
	},
	driversInfo: {
		mainDriver: {
			firstName: '',
			lastName: '',
			mobile: '',
			email: ''
		},
		additionalDrivers: []
	},
	billingOwnerInfo: {
		first: {
			customerId: '',
			firstName: '',
			lastName: '',
			fiscalCode: '',
			gender: null,
			birthDate: null,
			birthNation: null,
			birthPlace: '',
			countryResidence: null,
			provinceResidence: null,
			cityResidence: null,
			address: '',
			streetNumber: '',
			prefix: null,
			mobile: '',
			firstEmail: '',
			secondEmail: '',
			certifiedEmail: '',
			billingCountry: null,
			billingProvince: null,
			billingCity: null,
			billingAddress: '',
			billingStreetNumber: '',

			legalEntity: '',
			companyName: '',
			vatNumberCountry: '',
			vatNumber: '',
			SDI: '',
			billingPostalCode: ''
		} as any,
		second: {} as IRaDetailViewBillingOwnerPerson | IRaDetailViewBillingOwnerVAT | IRaDetailViewBillingOwnerCompany
	} as IRaDetailViewBillingOwnerInfo,
	extensionInfo: [],
	ancillariesInfo: {
		booked: [],
		counterSale: []
	}
}